const React = require('react');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const RowB = require('../../../dumb/Row/B');
const ColA = require('../../../dumb/Col/A');
const ColB = require('../../../dumb/Col/B');
const {TableNumberColAmin} = require("../../../dumb/TableNumberCol");


const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/merchantStatistic')
      .apiAdminMerchantStatisticList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const id = data.merchant_id;
      const eth = data.eth_count || 0;
      const btc = data.btc_count || 0;
      const total = data.total_count || 0;
      const averagePrice = data.average_price || 0;
      const medianPrice = data.median_price || 0;
      const turnover = data.turnover || 0;
      return (
        <RowA>
          <ColA className="wmin180 fx1">
            <DisplayIdAdmin>{id}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin200 fx1">
            <DisplayDataAdmin>{data.merchant_name}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={turnover}
              type="coin"
            />
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={eth}
              type="coin"
            />
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={btc}
              type="coin"
            />
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={total}
              type="coin"
            />
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={averagePrice}
              type="coin"
            />
          </ColA>
          <ColA className="wmin100 fx1">
            <DisplayAmountAdmin
              amount={medianPrice}
              type="coin"
            />
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Merchant statistic</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin1200 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin180 fx1">ID</ColB>
                    <ColB className="wmin200 fx1">Merchant<br/>Email</ColB>
                    <ColB className="wmin100 fx1">Turnover</ColB>
                    <ColB className="wmin100 fx1">ETH</ColB>
                    <ColB className="wmin100 fx1">BTC</ColB>
                    <ColB className="wmin100 fx1">Total</ColB>
                    <ColB className="wmin100 fx1">Average<br/>price</ColB>
                    <ColB className="wmin100 fx1">Median<br/>price</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
